import { type ClassValue, clsx } from 'clsx';

/**
 * Project-owned class-composition helper — the single place `clsx` is imported.
 * Component and app code call `classNames(...)`, never `clsx` directly, so the
 * underlying library can be swapped in one spot.
 */
export function classNames(...inputs: ClassValue[]): string {
	return clsx(inputs);
}
